import React from 'react'
import { useIntl } from 'react-intl'

import { SectionLastCTA } from '../../components/SectionLastCTA'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { SectionAiSearchHero } from './SectionAiSearchHero'
import { SectionAiSearchHowItWorks } from './SectionAiSearchHowItWorks'
import { SectionAiSearchMetrics } from './SectionAiSearchMetrics'
import { SectionAiSearchTestimonials } from './SectionAiSearchTestimonials'
import { SectionAiSearchUseCases } from './SectionAiSearchUseCases'
import { SectionAiSearchWhereYouWork } from './SectionAiSearchWhereYouWork'

export default function AiSearchPage() {
  const intl = useIntl()
  const routes = useRoutes()

  const pageTitle = intl.formatMessage({
    id: 'aiSearch.helmet.title',
    defaultMessage: 'AI search and retrieval, across all your company tools',
  })
  const pageDescription = intl.formatMessage({
    id: 'aiSearch.helmet.description',
    defaultMessage:
      'Give your team instant answers and power your custom agents from Slack, Notion, Google Drive, Jira, and 20+ sources — with citations you can trust.',
  })

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      canonicalUrl={routes.aiSearch()}
      background="moon-dust-lighter"
    >
      <SectionAiSearchHero />
      <SectionAiSearchMetrics />
      <SectionAiSearchUseCases />
      <SectionAiSearchWhereYouWork />
      <SectionAiSearchHowItWorks />
      <SectionAiSearchTestimonials />
      <SectionLastCTA background="moon-dust-lighter" />
    </SlitePage>
  )
}
